import { render } from "./FooterShow.vue?vue&type=template&id=0702b526&scoped=true"
import script from "./FooterShow.vue?vue&type=script&lang=js"
export * from "./FooterShow.vue?vue&type=script&lang=js"

import "./FooterShow.vue?vue&type=style&index=0&id=0702b526&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0702b526"],['__file',"src/views/AfterSales/editTask/components/FooterShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0702b526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0702b526', __exports__)) {
    api.reload('0702b526', __exports__)
  }
  
  module.hot.accept("./FooterShow.vue?vue&type=template&id=0702b526&scoped=true", () => {
    api.rerender('0702b526', render)
  })

}


export default __exports__